__webpack_require__.p = "/stolity-admin/";